<template>
  <div>
    <div class="flow-block">
      <h4 class="flow-title">1. Selecione as dashes</h4>
      <p class="flow-subtitle">Escolha todas as dashes que vão receber a campanha em massa.</p>
      <div class="step-status-item" :class="{ ok: hasSelectedTenants }">
        Selecionadas: {{ selectedTenantsCount }}
      </div>

      <div class="mt-2">
        <tenants-slim-list
          checkbox
          minimum
          searchable
          search-placeholder="Filtrar dash por nome"
          :only-actives="true"
          :selecteds="form.tenantIds"
          @selectedTenant="$emit('selected-tenant', $event)"
        />
      </div>
    </div>

    <div class="flow-block mt-5">
      <h4 class="flow-title">2. Defina o tenant modelo</h4>
      <p class="flow-subtitle">
        Usamos esse tenant para carregar instâncias, grupos, modelos e fluxos sugeridos.
      </p>
      <div class="d-flex flex-wrap" style="gap: 10px; align-items: flex-end;">
        <div style="min-width: 320px;">
          <vs-select
            :value="referenceTenantId"
            class="w-full"
            placeholder="Selecione um tenant dentre os marcados"
            autocomplete
            @input="$emit('update-reference-tenant-id', $event)"
          >
            <vs-select-item
              :key="item.id"
              v-for="item in referenceTenantOptions"
              :value="item.id"
              :text="item.label"
            />
          </vs-select>
        </div>

        <vs-button color="warning" type="border" @click="$emit('load-options')" :disabled="!referenceTenantId || loadingOptions">
          Recarregar sugestões
        </vs-button>
      </div>

      <p class="step-load-status mt-3 mb-0" :class="{ ok: referenceLoaded, warning: hasReferenceTenant && !referenceLoaded }">
        <span v-if="loadingOptions">Carregando sugestões do tenant modelo...</span>
        <span v-else-if="referenceLoaded">Sugestões carregadas para {{ referenceTenantLabel }}.</span>
        <span v-else-if="hasReferenceTenant">Aguarde o carregamento automático das sugestões.</span>
        <span v-else>Selecione um tenant modelo para continuar.</span>
      </p>
    </div>
  </div>
</template>

<script>
import TenantsSlimList from '@/views/Tenants/TenantsSlimList.vue';

export default {
  name: 'MassCampaignStepOne',
  components: {
    TenantsSlimList,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    referenceTenantId: {
      type: [Number, String],
      default: null,
    },
    referenceTenantOptions: {
      type: Array,
      required: true,
    },
    referenceTenantLabel: {
      type: String,
      default: null,
    },
    referenceLoaded: {
      type: Boolean,
      required: true,
    },
    loadingOptions: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    selectedTenantsCount() {
      return Array.isArray(this.form.tenantIds) ? this.form.tenantIds.length : 0;
    },
    hasSelectedTenants() {
      return this.selectedTenantsCount > 0;
    },
    hasReferenceTenant() {
      return this.referenceTenantId !== null && this.referenceTenantId !== undefined && `${this.referenceTenantId}` !== '';
    },
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
}

.flow-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}

.flow-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 10px;
}

.flow-block {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 14px;
  background: #fff;
}

.step-status-item {
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  color: #64748b;
  background: #f1f5f9;
  font-weight: 600;
  display: inline-flex;
}

.step-status-item.ok {
  border-color: #24a148;
  color: #1e8a3a;
  background: #edf9f1;
}

.step-load-status {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
}

.step-load-status.ok {
  color: #1e8a3a;
}

.step-load-status.warning {
  color: #b45309;
}
</style>
